/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Team_Api_NoteInputs */

const en_mk_team_api_note = /** @type {(inputs: Mk_Team_Api_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The payer does not switch automatically when a provider fails. Infrastructure allowances still apply.`)
};

const id_mk_team_api_note = /** @type {(inputs: Mk_Team_Api_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sumber biaya tidak berganti otomatis saat provider gagal. Kuota infrastruktur tetap berlaku.`)
};

/**
* | output |
* | --- |
* | "The payer does not switch automatically when a provider fails. Infrastructure allowances still apply." |
*
* @param {Mk_Team_Api_NoteInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_team_api_note = /** @type {((inputs?: Mk_Team_Api_NoteInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Team_Api_NoteInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_team_api_note(inputs)
	return en_mk_team_api_note(inputs)
});